
<template>
  <div class="scores-container">
    <!-- Total Liabilities Card -->
    <div class="risk-score-card">
        <i class="fa fa-user risk-icon"></i>
       
        <span class="personal-assets">Personal Assets: ${{ totalPersonalAssets.toFixed(2) }} CAD</span>
<button @click="showAddAssetForm = true" class="buttons" aria-label="Add New">
  <i class="fas fa-plus">Add</i>
</button>
  </div> 


    <!---SHOW PERSONAL ASSETS-->
    <div class="assets-container">
    <div v-if="assets.length" class="asset-cards">
      <div v-for="(asset, index) in assets" :key="index" class="asset-card">
        <i :class="getIconClass(asset.asset_type)" aria-hidden="true" class="logo"></i>
        <div v-if="!asset.isEditing" class="asset-details" @click="selectAssetForEdit(asset, index)">
          <h3>{{ asset.name }}</h3>
          <p>Value: ${{ asset.value }} CAD</p>
          <!-- Additional fields -->
          <i class="edit-icon fas fa-edit" @click="toggleEditMode(index)">Edit</i>
        </div>
        <div v-if="asset.isEditing">
          <!-- Editable Fields Here -->
          <input type="text" v-model="asset.name" />
          <input type="number" v-model.number="asset.value" />
          <!-- Other editable fields -->
          <button @click="updateAsset(index)">Save</button>
        </div>
      </div> 

    </div>
    <p v-else>No assets found.</p></div>
    
     
        <!---Add new PERSONAL ASSETS-->


       
   
         <!-- Form with v-if directive -->
         <form v-if="showAddAssetForm" @submit.prevent="addPersonalAsset">
      <input v-model="newAsset.name" placeholder="Asset Name" required class="assetinput">
      <select v-model="newAsset.asset_type" required>
        <option v-for="(label, value) in assetChoices" :key="value" :value="value">{{ label }}</option>
      </select>
      <input v-model.number="newAsset.value" type="number" placeholder="Value" required class="assetinput">
      <select v-if="newAsset.asset_type !== 'house'" v-model="newAsset.status" required class="assetinput">
  <option v-for="(label, value) in statusChoices" :key="value" :value="value">{{ label }}</option>
</select>

      <!-- Car-specific Fields -->
      <div v-if="newAsset.asset_type === 'car'">
        <input v-model.number="newAsset.car_year" type="number" placeholder="Car Year" class="assetinput">
        <input v-model="newAsset.car_make" placeholder="Car Make" class="assetinput">
        <input v-model="newAsset.car_model" placeholder="Car Model" class="assetinput">
      </div>

      <!-- House-specific Fields -->
      <div v-if="newAsset.asset_type === 'house'">
        <select v-model="newAsset.house_type">
          <option v-for="(label, value) in houseTypes" :key="value" :value="value">{{ label }}</option>
        </select>
      </div>

      <!-- Art-specific Fields -->
      <div v-if="newAsset.asset_type === 'art'">
        <input v-model="newAsset.artist" placeholder="Artist" class="assetinput">
        <input v-model="newAsset.title" placeholder="Title" class="assetinput">
        <select v-model="newAsset.condition">
          <option v-for="(label, value) in conditionChoices" :key="value" :value="value">{{ label }}</option>
        </select>
        <input v-model.number="newAsset.appraisal_value" type="number" placeholder="Appraisal Value" class="assetinput">
      </div>

      <button class="buttons" type="submit">Add Asset</button>
      <button @click.prevent="showAddAssetForm = false" class="buttons">Close</button>
  
    </form>
<br>
  </div><br>
  </template>
  
  <script>
import axios from 'axios';
import { Auth } from 'aws-amplify';

export default {
  data() {
    return {
      showAddAssetForm: false,
      assets: [],
      newAsset: {
        name: '',
        asset_type: '',
        value: 0,
        status: '',
        car_year: null,
        car_make: '',
        car_model: '',
        house_type: '',
        artist: '',
        title: '',
        condition: '',
        appraisal_value: null
      },
      assetChoices: {
        'car': 'Car',
        'house': 'House',
        'boat': 'Boat',
        'ATV': 'ATV',
        'RV': 'RV',
        'tractor': 'Tractor',
        'jewelry': 'Jewelry',
        'art': 'Art',
        'privateequity': 'Private Equity',
        'privatecredit': 'Private Credit',
        'livestock': 'Livestock',
        'other': 'Other',
      },
      statusChoices: {
        'financed': 'Financed',
        'leased': 'Leased',
        'owned': 'Owned Outright'
      },
      houseTypes: {
        'two_or_more_story': 'Two or More Story',
        'one_and_half_story': 'One and a Half Story',
        'split_level': 'Split-Level',
        'bungalow': 'Bungalow',
        'townhouse': 'Townhouse',
        'condo': 'Condominium',
      },
      conditionChoices: {
        'excellent': 'Excellent',
        'good': 'Good',
        'fair': 'Fair',
        'poor': 'Poor',
      },
      isEditingAsset: false,
      selectedAsset: null, 

    };
    
    
  },
  computed: {
    totalPersonalAssets() {
      return this.assets.reduce((sum, asset) => {
        return sum + (parseFloat(asset.value) || 0);
      }, 0);
    },
  },
  methods: {
  getIconClass(assetType, isFinancialAsset = false) {
    if (isFinancialAsset) {
      // FontAwesome classes for financial assets
      switch (assetType) {
        case 'depository':
          return 'fa-solid fa-piggy-bank'; // Class for depository assets
        case 'investment':
          return 'fa-solid fa-chart-line'; // Class for investment assets
        case 'employer_sponsored':
          return 'fa-solid fa-briefcase'; // Class for employer sponsored assets
        default:
          return 'fa-solid fa-circle-dot'; // Default class for other types
      }
    } else {
      // FontAwesome classes for personal assets
      switch (assetType) {
        case 'car':
          return 'fa fa-car';
        case 'house':
          return 'fa fa-home';
        case 'boat':
          return 'fa fa-ship';
        case 'ATV':
          return 'fa fa-motorcycle';
        case 'RV':
          return 'fa fa-caravan';
        case 'tractor':
          return 'fa fa-tractor';
        case 'jewelry':
          return 'fa fa-gem';
        case 'art':
          return 'fa fa-palette';
        case 'privateequity':
        case 'privatecredit':
          return 'fa fa-file-invoice-dollar';
        case 'livestock':
          return 'fa fa-horse';
        default:
          return 'fa-solid fa-chart-line'; // Default class for other types
      }
    }
  },
  

    toggleEditMode(index) {
      this.assets[index].isEditing = !this.assets[index].isEditing;
    },

    selectFinancialAssetForEdit(asset, index) {
      this.selectedFinancialAsset = { ...asset };
      this.selectedFinancialAssetIndex = index; // Store the index of the selected financial asset
      this.financialAssets[index].isEditing = true;
    },

    selectAssetForEdit(asset, index) {
      this.assets[index].isEditing = true;
      this.selectedAsset = { ...asset }; // Clone the asset for editing
    },

    async updateAsset(index) {
    try {
      const asset = this.assets[index];
      const user = await Auth.currentAuthenticatedUser();
      const cognitoSub = user.attributes.sub;
      const config = { headers: { 'X-Cognito-Sub': cognitoSub } };
      await axios.put(`https://api.riskypaws.com/frontoffice/api/personal-assets/${asset.id}/`, asset, config);
      this.assets[index].isEditing = false;
      await this.fetchAssets(); // Refresh the assets list
    } catch (error) {
      console.error('Error updating asset:', error);
    }
  },

  async deleteAsset(assetId, index) {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const cognitoSub = user.attributes.sub;
      const config = { headers: { 'X-Cognito-Sub': cognitoSub } };
      await axios.delete(`https://api.riskypaws.com/frontoffice/api/personal-assets/${assetId}`, config);
      this.assets.splice(index, 1); // Remove the asset from the list
    } catch (error) {
      console.error('Error deleting asset:', error);
    }
  },

    // Financial Asset Methods
    toggleFinancialEditMode(index) {
      this.financialAssets[index].isEditing = !this.financialAssets[index].isEditing;
    },


    async updateFinancialAsset(index) {
  try {
    const asset = this.financialAssets[index];
    // Check if asset and asset.id are valid
    if (!asset || !asset.id) {
      console.error("Invalid asset data", asset);
      return;
    }
    const user = await Auth.currentAuthenticatedUser();
    const cognitoSub = user.attributes.sub;
    const config = { headers: { 'X-Cognito-Sub': cognitoSub } };
    await axios.put(`https://api.riskypaws.com/frontoffice/api/assets/${asset.id}/`, asset, config);
    this.financialAssets[index].isEditing = false;
    await this.fetchFinancialAssets(); // Refresh the list
  } catch (error) {
    console.error('Error updating financial asset:', error);
  }
    },

    async deleteFinancialAsset(assetId, index) {
      try {
        const user = await Auth.currentAuthenticatedUser();
        const cognitoSub = user.attributes.sub;
        const config = { headers: { 'X-Cognito-Sub': cognitoSub } };
        await axios.delete(`https://api.riskypaws.com/frontoffice/api/assets/${assetId}`, config);
        this.financialAssets.splice(index, 1); // Remove the asset from the list
      } catch (error) {
        console.error('Error deleting financial asset:', error);
      }
    },

    async fetchAssets() {
      try {
        const user = await Auth.currentAuthenticatedUser();
        const cognitoSub = user.attributes.sub;
        const config = { headers: { 'X-Cognito-Sub': cognitoSub } };
        const response = await axios.get('https://api.riskypaws.com/frontoffice/api/personal-assets/', config);
        this.assets = response.data;
      } catch (error) {
        console.error('Error fetching assets:', error);
      }
    },
    async addPersonalAsset() {
      try {
        const user = await Auth.currentAuthenticatedUser();
        const cognitoSub = user.attributes.sub;
        const config = { headers: { 'X-Cognito-Sub': cognitoSub } };

        if (this.newAsset.asset_type === 'house') {
          this.newAsset.status = 'owned';
        }

        await axios.post('https://api.riskypaws.com/frontoffice/api/personal-assets/', this.newAsset, config);
        this.resetForm();
        await this.fetchAssets();
        this.showAddAssetForm = false;
      } catch (error) {
        console.error('Error adding new asset:', error);
      }
    },
    resetForm() {
      this.newAsset = {
        name: '',
        asset_type: '',
        value: '',
        status: '',
        car_year: null,
        car_make: '',
        car_model: '',
        house_type: '',
        artist: '',
        title: '',
        condition: '',
        appraisal_value: null
      };
    },
    async fetchFinancialAssets() {
      try {
        const user = await Auth.currentAuthenticatedUser();
        const cognitoSub = user.attributes.sub;
        const config = { headers: { 'X-Cognito-Sub': cognitoSub } };
        const response = await axios.get('https://api.riskypaws.com/frontoffice/api/assets/', config);
      this.financialAssets = response.data;
      } catch (error) {
        console.error('Error fetching financial assets:', error);
      }
    },
    async addFinancialAsset() {
      try {
        const user = await Auth.currentAuthenticatedUser();
        const cognitoSub = user.attributes.sub;
        const config = { headers: { 'X-Cognito-Sub': cognitoSub } };
        await axios.post('https://api.riskypaws.com/frontoffice/api/assets/', this.newFinancialAsset, config);
        this.resetFinancialAssetForm();
        this.showAddFinancialAssetForm = false;
        await this.fetchFinancialAssets(); // Refresh the list
      } catch (error) {
        console.error('Error adding financial asset:', error);
      }

      
    },

    
    resetFinancialAssetForm() {
      this.newFinancialAsset = {
        // Reset fields to their initial state
      };
    },
  },
  async mounted() {
    await this.fetchAssets();
  
  }
};
</script>
  
<style scoped>

.assets-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}
.asset-card {
  background-color: #36454f;
  color: white;
  border-radius: 15px;
  padding: 20px;
  margin: 10px;
  width: 300px;
  height: 150px;
  transition: transform 0.3s ease;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between; /* Space between top and bottom sections */
  align-items: center;
  background-image: url('@/assets/personalasset.png'); /* Adjust the path as needed */
  background-size: cover; /* This will cover the entire area of the card */
  background-position: center; /* Center the image in the card */
  background-repeat: no-repeat; /* Prevent the image from repeating */
  overflow: hidden; /* Ensures nothing spills out of the card's rounded corners */
}




/* Style for the bottom section containing asset details and edit icon */
.asset-card .bottom-section {
  width: 100%; /* Ensure full width for the bottom section */
  display: flex;
  justify-content: space-between; /* Space between details and icon */
  align-items: center; /* Center content vertically */
}

/* Style for the edit icon */
.asset-card .edit-icon {
  font-size: 1.5em;
  color: white;
  cursor: pointer;
}

.asset-card:hover {
  transform: scale(1.05);
  background-color: black;
}

.asset-card i {
  font-size: 2em;
  margin-bottom: 10px;
}

.personal-assets {
  font-size: 1.2em; /* Default font size */
}

/* Media query for smaller screens */
@media (max-width: 768px) {
  .personal-assets {
    font-size: 1em; /* Smaller font size for mobile devices */
  }
}
.wrapper {
 display: flex;
 flex-direction: column;
 align-items: center;
}

.content-container {
 background-color: #4A148C;
 color: black;
 padding: 20px;
 border-radius: 20px;
 overflow: hidden;
 
}

.logo {
  align-items: left;
}
.stingy-card {
 flex: 1;
 padding: 20px;
 border-radius: 8px;
 box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
 background-color: white;
}

.asset-cards {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start; /* Align cards to the start of the container */
}

.add-asset-btn {
  background-color: #6a5acd; /* RiskyPaws Purple */
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.add-asset-btn:hover {
  background-color: black;
}

.assetinput {
  margin: 5px 0; /* Spacing for inputs */
  padding: 10px; /* Padding for inputs */
  border-radius: 10px; /* Rounded corners for inputs */
  border: 1px solid #6a5acd; /* RiskyPaws Purple */
  width: 50%;

}
select,
input[type="text"],
input[type="number"],
input[type="date"] {
  width: 50%;
  padding: 10px;
  margin: 5px 0;
  border-radius: 10px;
  border: 1px solid #6a5acd; /* RiskyPaws Purple */
  box-sizing: border-box;
}

.risk-score-card {
display: flex;
align-items: center;
width: 100%;
padding: 20px;
margin-bottom: 20px;
background-color: #36454f;
color: white;
font-size: 20px;
border-radius: 10px;
box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
justify-content: space-between;
}

.input-field, select {
  width: 100%;
  padding: 10px;
  margin: 5px 0;
  border-radius: 8px;
  border: 1px solid #6a5acd; /* RiskyPaws Purple */
  box-sizing: border-box;
}
.scores-container {
  display: flex;
  flex-wrap: wrap; /* Allows items to move to the next row on smaller screens */
  justify-content: center; /* Centers items */
  align-items: center;
  width: 100%;
  border: 2px solid #4A148C;
  border-radius: 10px;
  padding: 20px;
  box-sizing: border-box;  
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;

}
.input-field:hover, select:hover {
  border-color: black;
}

.input-field:focus, select:focus {
  outline: none;
  border-color: #6a5acd;
  box-shadow: 0 0 8px 0 rgba(106, 90, 205, 0.5); /* Light purple glow */
}

button {
  background-color: #4A148C; /* Purple background */
  color: white; /* White text */
  border: none;
  border-radius: 5px; /* Rounded corners */
  padding: 10px 20px; /* Padding inside the button */
  cursor: pointer; /* Cursor style */
  transition: background-color 0.3s ease; /* Smooth transition for hover effect */
}

button:hover {
  background-color: black; /* Black background on hover */
}

@media (min-width: 768px) { /* Adjust the min-width as needed */
  .risk-score-card {
    justify-content: space-between; /* Aligns items to start and end */
  }

  .refresh-button {
    margin-left: 0; /* Removes left margin on larger screens */
    /* Additional styles for larger screens if needed */
  }
}
</style>